import React from "react";
import { useParams } from "react-router-dom";
//#region types
import { WintSuperkollAPIModelQualifiedShareDividend } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  useAPIRequestKeyRef,
  EntityCardLayout,
  Skeletons,
} from "components/common";
import QualifiedShareDividend from "./dividend";
import { ErrorView } from "components/error";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { ServiceHelper } from "utils/helpers";

const QualifiedShareDividendView: React.FC = () => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  const urlParams = useParams<EntityIdParams>();
  const id = urlParams.id ?? "0";

  const { getMounted } = useMountedState();
  const { goBack } = useNavigationHistory();

  const [notFound, setNotFound] = React.useState<boolean>();
  const [qualifiedShareDividend, setQualifiedShareDividend] =
    React.useState<WintSuperkollAPIModelQualifiedShareDividend.QualifiedShareDividend>();
  const [key, setKey] = React.useState(0);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadQualifiedShareDividend = (
    onSuccess?: (qualifiedShareDividend: WintSuperkollAPIModelQualifiedShareDividend.QualifiedShareDividend) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    ServiceHelper.withAPIRequestKey(qualifiedShareDividendsService.getQualifiedShareDividend(id), currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setQualifiedShareDividend(result.data);
          setKey(key + 1);
        }
        onSuccess && onSuccess(result.data);
      })
      .catch(() => {
        if (qualifiedShareDividend) {
          setTimeout(() => {
            goBack();
          }, 1000);
          onError && onError();
        } else setNotFound(true);
      });
  };

  React.useEffect(() => {
    setQualifiedShareDividend(undefined);
    loadQualifiedShareDividend();
  }, [id]);

  return notFound ? (
    <ErrorView />
  ) : (
    <>
      <PageLayouts.EntityFullScreen
        entityKey={`qualified-share-dividend`}
        id={qualifiedShareDividend?.id ? parseInt(qualifiedShareDividend?.id) : 0}
        className={clsx(cssExports.transparent, cssExports.cardNavigation)}
      >
        <EntityCardLayout>
          {qualifiedShareDividend ? (
            <QualifiedShareDividend
              qualifiedShareDividend={qualifiedShareDividend}
              reloadHandler={loadQualifiedShareDividend}
            />
          ) : (
            <Skeletons.EntityCardSkeleton />
          )}
        </EntityCardLayout>
      </PageLayouts.EntityFullScreen>
    </>
  );
};

export default QualifiedShareDividendView;
